import { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Unstable_Grid2';
import { BsThreeDots } from 'react-icons/bs';
import Typography from '@mui/material/Typography';

export const SourcesList = ({ responseData }) => {
  const posts = responseData?.documents
  const [showViewMore, setShowViewMore] = useState(true);

  const handleViewMoreClick = () => {
    setShowViewMore(false);
  };

  const renderFourthPost = () => {
    if (posts.length === 4) {
      const post = posts[3];
      return (
        <Grid key={3}

          xs={3}
          md={3}
          mb={3}
          onClick={() => window.open(post.url, "_blank")}>
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              p: 1,
              borderRadius: 0.8,
              backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100'),
            }}
          >
            <Box>
              <Typography
                color="text.primary"
                variant="body1"
                sx={{
                  mb: 0.5,
                  fontSize: '0.85rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                  height: '3em',
                }}
                title={post.title}
              >
                {post.title}
              </Typography>
              <Grid container
                spacing={1}
                alignItems="center">
                <Grid item>
                  <Avatar src={post.thumbnail}
                    sx={{ width: 24, height: 24 }} />
                </Grid>
                <Grid item>
                  <Typography
                    color="text.secondary"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: 1,
                    }}
                    variant="body2"
                  >
                    {post.source.length > 9 ? `${post.source.slice(0, 6)}...` : post.source} · {4}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Card>
        </Grid>
      );
    }
    return null;
  };

  const renderMoreThan6Posts = () => {
    if (posts.length > 6 && showViewMore) {
      return (
        <Grid item>
          <BsThreeDots size={20} />
        </Grid>
      );
    }
    return null;
  };

  const renderViewMore = () => {
    if (posts.length > 4 && showViewMore) {
      // limit it 6 if more than 6 posts
      const howManyMore = posts.length - 3;
      const limit = posts.length > 6 ? 6 : posts.length;
      const extraPosts = posts.slice(3, limit);
      return (
        <Grid key={3}
          xs={3}
          md={3}
          mb={3}
          onClick={handleViewMoreClick} >
          <Card
            sx={{
              cursor: 'pointer',
              height: '100%',
              p: 1,
              pb: 0,
              borderRadius: 0.8,
              backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100'),
            }}
          >
            <Grid container
              spacing={1}
              alignItems="center">
              {
                extraPosts.map((post, idx) => (
                  <Grid key={idx} item>
                    <Avatar src={post.thumbnail}
                      sx={{ width: 24, height: 24 }} />
                  </Grid>
                ))
              }
              {renderMoreThan6Posts()}
              <Grid item
                alignItems={"bottom"}>
                <Typography
                  color="text.primary"
                  variant="body1"
                  sx={{
                    fontSize: '0.85rem',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    height: '3em',
                    pt: 1.5
                  }}
                  title={"a"}
                >
                  View {howManyMore} more
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      );
    }
    return null;
  };

  const renderPosts = () => {
    if (showViewMore) {
      return (
        <>
          {
            posts.slice(0, 3).map((post, idx) => (
              <Grid key={post.id}
                xs={3}
                md={3}
                mb={3}
                onClick={() => window.open(post.url, "_blank")}>
                <Card
                  sx={{
                    cursor: 'pointer',
                    height: '100%',
                    p: 1,
                    borderRadius: 0.8,
                    backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100'),
                  }}
                >
                  <Box>
                    <Typography
                      color="text.primary"
                      variant="body1"
                      sx={{
                        mb: 0.5,
                        fontSize: '0.85rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        height: '3em',
                      }}
                      title={post.title}
                    >
                      {post.title}
                    </Typography>
                    <Grid container
                      spacing={1}
                      alignItems="center">
                      <Grid item>
                        <Avatar src={post.thumbnail}
                          sx={{ width: 24, height: 24 }} />
                      </Grid>
                      <Grid item>
                        <Typography
                          color="text.secondary"
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 1,
                          }}
                          variant="body2"
                        >
                          {post.source.length > 10 ? `${post.source.slice(0, 7)}...` : post.source} · {idx + 1}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            ))
          }
        </>
      );
    } else {
      var mbDeterminingFactor = null;
      if (posts.length % 4 === 0) {
        mbDeterminingFactor = posts.length - 5;
      } else {
        mbDeterminingFactor = posts.length - (posts.length % 4) - 1;
      }
      return (
        <>
          {
            posts.map((post, idx) => (
              // on click redirect to post.url
              <Grid key={post.id}
                xs={3}
                md={3}
                mb={idx > mbDeterminingFactor ? 3 : 0}
                onClick={() => window.open(post.url, "_blank")}>
                <Card
                  sx={{
                    cursor: 'pointer',
                    height: '100%',
                    p: 1,
                    borderRadius: 0.8,
                    backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'neutral.800' : 'neutral.100'),
                  }}
                >
                  <Box>
                    <Typography
                      color="text.primary"
                      variant="body1"
                      sx={{
                        mb: 0.5,
                        fontSize: '0.85rem',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        height: '3em',
                      }}
                      title={post.title}
                    >
                      {post.title}
                    </Typography>
                    <Grid container
                      spacing={1}
                      alignItems="center">
                      <Grid item>
                        <Avatar src={post.thumbnail}
                          sx={{ width: 24, height: 24 }} />
                      </Grid>
                      <Grid item>
                        <Typography
                          color="text.secondary"
                          sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 1,
                          }}
                          variant="body2"
                        >
                          {post.source.length > 10 ? `${post.source.slice(0, 7)}...` : post.source} · {idx + 1}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
            ))
          }
        </>
      );
    }
  }
  if (!posts) {
    return null;
  }
  return (
    <Box sx={{ px: 3 }}>
      <Grid container
        spacing={3}>
        {renderPosts()}
        {renderFourthPost()}
        {renderViewMore()}
      </Grid>
    </Box>
  );
};
